module.exports = __webpack_public_path__ + "b356a99f551570cb0e5a7c00198acbdd.png";